export default __webpack_public_path__ + "static/media/header-logo.1a4c3922.jpg";